export const faqCategories = [
  { id: 'buying-process', label: 'Buying Process', icon: 'ri-car-line' },
  { id: 'auto-broker', label: 'Auto Broker', icon: 'ri-service-line' },
  { id: 'first-time-buyer', label: 'First-Time Buyers', icon: 'ri-user-star-line' },
  { id: 'financing', label: 'Financing', icon: 'ri-bank-card-line' },
  { id: 'trade-in', label: 'Trade-Ins', icon: 'ri-exchange-line' },
  { id: 'taxes-fees', label: 'Taxes & Fees', icon: 'ri-percent-line' },
  { id: 'delivery', label: 'Delivery & Pickup', icon: 'ri-truck-line' },
  { id: 'sell-your-car', label: 'Sell Your Car', icon: 'ri-price-tag-3-line' },
  { id: 'ev-hybrid', label: 'EV & Hybrid', icon: 'ri-charging-pile-line' },
  { id: 'local-services', label: 'Service Areas', icon: 'ri-map-pin-line' },
  { id: 'vehicle-quality', label: 'Vehicle Quality', icon: 'ri-shield-check-line' },
];

export const popularQuestions = [
  'What is your doc fee?',
  'Can I get pre-approved online?',
  'Do you deliver to my area?',
  'How do trade-ins work?',
  'Do you sell EVs?',
  'What credit score do I need?',
];

export const faqItems = [
  // ── Buying Process ──────────────────────────────────────────────────────────
  {
    category: 'buying-process',
    question: 'How do I buy a used car from Rockhound Auto in Warrenton, Oregon?',
    answer:
      'Browse our inventory online, find something you like, and call us at (855) 468-6348 or schedule a test drive. We handle the paperwork, financing, and DMV work — you just show up and drive away. No "let me get my manager" moments. No four-hour negotiation sessions. Just a car you actually want at a price that makes sense.',
  },
  {
    category: 'buying-process',
    question: 'What documents do I need to purchase a vehicle in Oregon?',
    answer:
      "A valid driver's license, proof of insurance, and proof of income if you're financing. That's it. We handle the title transfer, DMV paperwork, and registration — whether you're in Oregon, Washington, or anywhere in the Pacific Northwest. You don't need to become a DMV expert. That's our job.",
  },
  {
    category: 'buying-process',
    question: 'Can I test drive a vehicle before purchasing?',
    answer:
      "Yes — and honestly, we'd be worried if you didn't want to. Every vehicle in our inventory is available for a test drive at our Warrenton showroom. Coming from Astoria, Seaside, Longview, or further out? Call ahead and we'll have it ready when you arrive. We're not going to rush you back in 10 minutes either.",
  },
  {
    category: 'buying-process',
    question: 'What is the best time of year to buy a used car on the Oregon Coast?',
    answer:
      "Late fall and winter tend to have softer demand and lower prices. But the honest answer: the best time to buy is when you find the right car at the right price. Our broker model keeps overhead low year-round, so we're not sitting on a massive lot waiting to unload inventory before the quarter ends.",
  },
  {
    category: 'buying-process',
    question: 'Can I buy a car entirely online without visiting in person?',
    answer:
      "Yes. We handle the full transaction remotely — video walkthroughs, digital paperwork, and home delivery. Many of our customers in Portland, Longview, and Seattle complete the entire purchase without ever visiting Warrenton. We'll ship the car to your door and you sign everything electronically.",
  },
  {
    category: 'buying-process',
    question: 'How long does the buying process take from start to finish?',
    answer:
      "For inventory vehicles, most buyers are done in 1–2 hours on-site — or the same day if doing it remotely. For broker-sourced vehicles, add 5–14 days for us to locate and transport the car. We don't drag things out. Once you say yes, we move fast.",
  },

  // ── Auto Broker ─────────────────────────────────────────────────────────────
  {
    category: 'auto-broker',
    question: 'What is an auto broker and how is it different from a dealership?',
    answer:
      "A dealership works for the dealership. An auto broker works for you. We search dealer networks, auctions, and private sellers nationwide to find exactly what you want — then we negotiate the price, arrange the inspection, and handle the paperwork. We don't have a lot full of cars we need to move. We have one goal: get you the right car for the right price.",
  },
  {
    category: 'auto-broker',
    question: 'How much money can I save using Rockhound Auto instead of a local dealership?',
    answer:
      "Our customers typically save $3,000 to $8,000 compared to buying from a traditional dealership. That comes from lower overhead, no inflated sticker prices, and a flat $995 broker fee instead of percentage-based markups. We also don't charge doc fees, dealer prep fees, or 'market adjustment' fees.",
  },
  {
    category: 'auto-broker',
    question: 'Can you find any make and model of vehicle?',
    answer:
      "Yes — any make, any model, any year, any trim. Toyota Tacoma for the trails, Subaru Outback for the rain, luxury SUV for the commute, electric vehicle for the future. We're not locked into one brand or one lot. If it exists in the US, we can find it.",
  },
  {
    category: 'auto-broker',
    question: 'How long does it take to find a vehicle through your broker service?',
    answer:
      "Most searches wrap up in 5 to 14 days. Common vehicles — Tacomas, CR-Vs, Outbacks — usually surface within a week. Rare or very specific builds might take 2–3 weeks. We keep you in the loop the whole time and nothing moves without your approval.",
  },
  {
    category: 'auto-broker',
    question: 'What is your broker fee and when do I pay it?',
    answer:
      "Our broker fee is a flat $995 for vehicles we source on your behalf. For vehicles already in our inventory, there's no broker fee at all. The fee is paid at closing — not upfront. You don't owe us anything until you have a car you love and a deal you've agreed to.",
  },
  {
    category: 'auto-broker',
    question: 'Do I need to sign anything to start the broker search process?',
    answer:
      "No commitment required to start. We'll have a quick conversation about what you're looking for, your budget, and your timeline. Once we find something that matches, we'll send you a simple broker agreement before anything moves forward. You're never locked in until you say yes to a specific vehicle.",
  },
  {
    category: 'auto-broker',
    question: 'What happens if I don\'t like the vehicle you find?',
    answer:
      "You're never obligated to buy a vehicle we source. If it doesn't match what we discussed — wrong color, wrong trim, something feels off — just say so. We go back to searching. We'd rather find the right car on the second try than pressure you into the wrong one on the first.",
  },
  {
    category: 'auto-broker',
    question: 'Can you source vehicles from out of state?',
    answer:
      "Yes. We search dealer auctions, wholesale networks, and dealer-to-dealer trades across the entire country. If the right Tacoma is sitting at an auction in Phoenix or a dealer lot in Denver, we can get it. We handle transport, inspection, and all the paperwork to get it registered in your state.",
  },
  {
    category: 'auto-broker',
    question: 'Is using a broker better than buying from a private seller?',
    answer:
      "For most buyers, yes. Private sellers offer no warranty, no financing, no inspection guarantee, and no recourse if something goes wrong. With us, you get a vetted vehicle, financing options, warranty availability, and a licensed dealer handling the title transfer. The peace of mind alone is usually worth more than any private-party discount.",
  },

  // ── Financing ───────────────────────────────────────────────────────────────
  {
    category: 'financing',
    question: 'Do you offer financing for used cars in Warrenton and Astoria?',
    answer:
      "Yes. We work with multiple lenders to find competitive financing for buyers across the Pacific Northwest. We shop lenders on your behalf, which means you're not stuck with whatever rate one bank decides to offer you on a Tuesday. All credit situations welcome.",
  },
  {
    category: 'financing',
    question: 'Can I get pre-approved for a car loan before visiting your Warrenton location?',
    answer:
      "Absolutely. Pre-approval takes minutes, doesn't affect your credit score, and gives you a real budget before you start shopping. Apply online or call (855) 468-6348. Then browse our inventory knowing exactly what you can spend.",
  },
  {
    category: 'financing',
    question: 'What credit score do I need to finance a vehicle?',
    answer:
      "There's no minimum. Better credit gets better rates — that's just math. But we have lending partners who specialize in every credit situation, including people who've been turned away elsewhere. If you're rebuilding, we'll be straight with you about what's realistic. No false promises, no bait-and-switch.",
  },
  {
    category: 'financing',
    question: 'Do you accept cash purchases or bank checks?',
    answer:
      "Yes — cash, certified bank checks, cashier's checks, and wire transfers all work. Cash buyers often have extra negotiating leverage, so mention it upfront. We also work with credit unions throughout the Pacific Northwest. If you've got a pre-approved rate from your own bank, bring it — we'll try to beat it.",
  },
  {
    category: 'financing',
    question: 'What is your typical interest rate range for auto loans?',
    answer:
      "Rates vary based on credit score, loan term, and lender. Well-qualified buyers typically see rates between 5–9% APR. Buyers with challenged credit may see higher rates, but we always show you multiple options so you can choose what works best for your budget. We never hide the rate until you're signing.",
  },
  {
    category: 'financing',
    question: 'Can I refinance my current auto loan through Rockhound Auto?',
    answer:
      "We don't directly offer refinancing, but we can point you toward credit unions and lenders in the Pacific Northwest who do. If you bought a car elsewhere at a high rate and want to lower your payment, call us — we'll give you honest guidance on your options.",
  },
  {
    category: 'financing',
    question: 'How much should I put down on a used car?',
    answer:
      "A 10–20% down payment is a solid target. It lowers your monthly payment, reduces the total interest you pay, and helps you avoid being upside-down on the loan. That said, we work with buyers at every down payment level — including $0 down for well-qualified applicants. Use our loan calculator on the Financing page to run the numbers before you commit.",
  },
  {
    category: 'financing',
    question: 'What is the difference between getting financed through a dealer vs. my own bank?',
    answer:
      "Your bank or credit union may offer a competitive rate, especially if you have an existing relationship. Dealer financing lets us shop multiple lenders at once and sometimes access rates your bank can't match. Best move: get pre-approved by your bank first, then let us try to beat it. You win either way.",
  },
  {
    category: 'financing',
    question: 'Will applying for financing hurt my credit score?',
    answer:
      "A full credit application (hard pull) will cause a small, temporary dip — typically 2–5 points. However, multiple auto loan inquiries within a 14–45 day window are usually counted as a single inquiry by the credit bureaus. So shopping around doesn't compound the impact. Pre-qualification uses a soft pull and has zero effect on your score.",
  },
  {
    category: 'financing',
    question: 'Can I finance a vehicle if I\'m self-employed or have non-traditional income?',
    answer:
      "Yes. Self-employed buyers, gig workers, and those with non-traditional income can absolutely finance a vehicle. You'll typically need 2 years of tax returns or bank statements showing consistent income. Some lenders specialize in exactly this situation. We'll match you with the right one.",
  },
  {
    category: 'financing',
    question: 'What loan terms are available — how many months can I finance?',
    answer:
      "Most lenders offer terms from 24 to 84 months. Shorter terms mean higher monthly payments but less total interest. Longer terms lower your payment but cost more over time. We'll show you side-by-side comparisons so you can see exactly what each term costs you — not just the monthly payment.",
  },
  {
    category: 'financing',
    question: 'Can I pay off my auto loan early without a penalty?',
    answer:
      "Most of our lending partners do not charge prepayment penalties. We'll confirm this for your specific loan before you sign. If you come into extra money and want to pay down the principal, you should be able to do so freely. Always verify with your lender directly after closing.",
  },

  // ── Trade-Ins ────────────────────────────────────────────────────────────────
  {
    category: 'trade-in',
    question: 'How does the trade-in process work at Rockhound Auto?',
    answer:
      "Submit your vehicle details online or bring it to our Warrenton location. We give you a fair market valuation based on actual condition, mileage, and current market data — not a lowball number designed to make you feel grateful for anything above zero. Our trade-in values are consistently higher than traditional dealerships.",
  },
  {
    category: 'trade-in',
    question: 'Will I get a better trade-in value at Rockhound Auto than at a dealership?',
    answer:
      "In most cases, yes — often $1,000 to $3,000 more. Traditional dealerships lowball trade-ins because they need to resell at a profit on their own lot. We access wholesale markets, auctions, and direct buyer networks, which means we can pay more and still make it work.",
  },
  {
    category: 'trade-in',
    question: 'Can I trade in a vehicle that I still owe money on?',
    answer:
      "Yes. We handle negative equity and payoff situations all the time. If you owe more than the car is worth, we can roll the difference into your new loan. If you have positive equity, it becomes your down payment. Either way, we'll walk you through the numbers clearly — no surprises buried in the paperwork.",
  },
  {
    category: 'trade-in',
    question: 'Do I have to buy a car from you to trade mine in?',
    answer:
      "No. We'll buy your car outright even if you're not purchasing from us. We pay fair market value and can have a check in your hand the same day. No pressure to buy anything. If you just want to sell your car and walk away with cash, that's a perfectly fine transaction.",
  },
  {
    category: 'trade-in',
    question: 'How do you determine my trade-in value?',
    answer:
      "We use a combination of current market data (Manheim, Black Book, KBB), actual condition assessment, regional demand, and recent comparable sales. We show you the data we're using — not just a number we made up. If you disagree with our assessment, tell us why. We're open to that conversation.",
  },
  {
    category: 'trade-in',
    question: 'Should I clean my car before bringing it in for a trade-in appraisal?',
    answer:
      "A clean car makes a better first impression and can help your appraisal. Basic cleaning — vacuuming, wiping down surfaces, washing the exterior — is worth doing. You don't need to spend $200 on a detail. Just don't bring it in with a week of fast food wrappers on the floor. Condition matters, and presentation is part of condition.",
  },
  {
    category: 'trade-in',
    question: 'What paperwork do I need to trade in my vehicle?',
    answer:
      "You'll need the title (or payoff information if you still owe), your driver's license, and any service records you have. If the title is in someone else's name, they'll need to be present or provide a notarized signature. We'll walk you through anything unusual for your specific situation.",
  },
  {
    category: 'trade-in',
    question: 'Does trading in my car reduce the sales tax I owe in Oregon?',
    answer:
      "Oregon has no sales tax on used vehicle purchases, so there's no sales tax offset to calculate at the point of sale — you're not paying sales tax to begin with. If you're a Washington resident registering in Washington, your trade-in value does reduce the taxable purchase price for Washington sales tax purposes — which can save you a meaningful amount at your WA DOL. We'll walk you through the full fee picture for your specific situation.",
  },
  {
    category: 'trade-in',
    question: 'Can I get a trade-in estimate online before coming in?',
    answer:
      "Yes. Use our Trade-In Calculator on the Trade-In page to get a ballpark estimate based on year, make, model, mileage, and condition. It's not a final offer — actual condition always affects the final number — but it gives you a realistic range before you make the trip.",
  },

  // ── Taxes & Fees ─────────────────────────────────────────────────────────────
  {
    category: 'taxes-fees',
    question: 'Do I save on taxes buying a car in Oregon if I live out of state?',
    answer:
      "No — and we'd rather tell you that upfront than let you find out at the DMV. You pay taxes based on where you register the vehicle, not where you buy it. Washington, California, and Idaho residents pay their home state's tax when they register. The real savings come from our wholesale pricing, lower markups, and flat $250 doc fee.",
  },
  {
    category: 'taxes-fees',
    question: 'What fees should I expect when buying a car in Oregon?',
    answer:
      "Oregon DMV title and registration fees ($268–$636 depending on vehicle value), and our flat $995 broker fee for sourced vehicles. That's it. No doc fees. No dealer prep. No 'market adjustment.' No fees that magically appear on page 4 of the contract. We put our fee on the website because we're not embarrassed by it.",
  },
  {
    category: 'taxes-fees',
    question: 'Are there any hidden fees at Rockhound Auto?',
    answer:
      "No. Our broker fee is $995 for sourced vehicles, $0 for inventory purchases. Standard DMV fees apply. Any optional warranty or service packages are your choice — we'll explain them clearly and never pressure you. The price you see is the price you pay. We put it in writing because we mean it.",
  },
  {
    category: 'taxes-fees',
    question: 'What is Oregon\'s vehicle privilege tax and does it apply to me?',
    answer:
      "Oregon's vehicle privilege tax (0.5% of the retail price) applies to new vehicles sold by Oregon dealers. Used vehicles are generally exempt. If you're buying a used car from us, this tax almost certainly doesn't apply to your purchase. We'll confirm on your specific deal.",
  },

  // ── Delivery & Pickup ────────────────────────────────────────────────────────
  {
    category: 'delivery',
    question: 'Do you offer vehicle delivery to my location in the Pacific Northwest?',
    answer:
      "Yes. We deliver throughout the Pacific Northwest — Astoria, Seaside, Tillamook, Longview, Kelso, Long Beach, Forest Grove, Hillsboro, Portland, and beyond. Delivery fees vary by distance, but a lot of customers find it's worth every penny compared to spending a Saturday driving to a dealership and back.",
  },
  {
    category: 'delivery',
    question: 'How much does vehicle delivery cost?',
    answer:
      "Delivery within 30 miles of Warrenton is often complimentary. Beyond that, fees are based on distance and typically range from $75–$250 for most Pacific Northwest locations. Long-distance delivery (Portland, Seattle, etc.) is available and priced per trip. We'll quote you exactly before you commit to anything.",
  },
  {
    category: 'delivery',
    question: 'Can I pick up my vehicle at your Warrenton location?',
    answer:
      "Absolutely. Our showroom is at 1425 SE 9th St, Warrenton, OR 97146. We're open Monday–Saturday. Call ahead and we'll have your vehicle detailed, fueled, and ready when you arrive. Pickup is always free and we'll walk you through every feature before you leave.",
  },
  {
    category: 'delivery',
    question: 'What happens if I don\'t like the car when it\'s delivered?',
    answer:
      "We do a thorough video walkthrough before delivery so there are no surprises. If something isn't right when the car arrives, we'll work it out — whether that means a return, an exchange, or a price adjustment. We're not going to leave you stuck with a car you're unhappy with. That's not how we operate.",
  },
  {
    category: 'delivery',
    question: 'Can you ship a vehicle to me outside the Pacific Northwest?',
    answer:
      "Yes. We can arrange enclosed or open transport to anywhere in the continental US through our network of licensed auto transporters. Typical transit times are 3–7 days depending on destination. Shipping costs vary by distance — we'll get you a quote within 24 hours of your request.",
  },

  // ── Sell Your Car ────────────────────────────────────────────────────────────
  {
    category: 'sell-your-car',
    question: 'How do I sell my car to Rockhound Auto?',
    answer:
      "Fill out our online form or call (855) 468-6348 with your vehicle's year, make, model, mileage, and condition. We'll give you a fair market offer within 24 hours. If you accept, bring the car in (or we can arrange pickup) and you'll have a check the same day. No haggling, no games.",
  },
  {
    category: 'sell-your-car',
    question: 'What types of vehicles do you buy?',
    answer:
      "Cars, trucks, SUVs, crossovers, vans, and specialty vehicles. We buy most makes and models from 2005 and newer with under 150,000 miles. High-demand vehicles like Toyota Tacoma, Subaru Outback, Honda CR-V, and Ford F-150 get top dollar. Even if your vehicle doesn't fit that profile, reach out — we may still be interested.",
  },
  {
    category: 'sell-your-car',
    question: 'Do you buy cars with mechanical issues or high mileage?',
    answer:
      "Sometimes, yes. It depends on the vehicle, the issue, and the market. We'll always give you an honest assessment. If we can't buy it at a price that works for both of us, we'll tell you that directly and suggest alternatives. We won't waste your time with a lowball offer just to get you in the door.",
  },
  {
    category: 'sell-your-car',
    question: 'How does consignment work if I want to sell through you?',
    answer:
      "With consignment, we list and sell your vehicle on your behalf. You set the minimum acceptable price, we handle marketing, showings, and paperwork. When it sells, you get your agreed amount minus our consignment fee. It typically gets you more than a direct sale because we can reach a wider buyer pool. Visit our consignment page for full details.",
  },
  {
    category: 'sell-your-car',
    question: 'How quickly can I get paid when selling my car?',
    answer:
      "Same day for direct purchases — you bring the car, we verify condition, we hand you a check. For consignment, payment is issued within 3 business days of the sale completing. We don't hold funds or delay payment. Once the deal is done, you get paid.",
  },

  // ── EV & Hybrid ──────────────────────────────────────────────────────────────
  {
    category: 'ev-hybrid',
    question: 'Do you sell electric vehicles (EVs) and hybrids?',
    answer:
      "Yes. We carry and source EVs and hybrids regularly — Tesla Model 3, Model Y, Chevy Bolt, Nissan Leaf, Toyota Prius, Ford Escape Hybrid, and more. EV inventory moves fast on the Oregon Coast, so if you don't see what you want in stock, use our broker service and we'll find it.",
  },
  {
    category: 'ev-hybrid',
    question: 'What should I know about buying a used EV on the Oregon Coast?',
    answer:
      "Battery health is the most important factor. We check battery state-of-health (SOH) on every used EV we sell and disclose it upfront. Oregon Coast weather is mild, which is actually good for battery longevity. We also verify charging history and any software updates. You'll know exactly what you're getting.",
  },
  {
    category: 'ev-hybrid',
    question: 'Are there federal or Oregon tax credits for used EVs?',
    answer:
      "Yes. The federal Used Clean Vehicle Credit offers up to $4,000 for qualifying used EVs purchased from a licensed dealer (that's us). Income limits apply. Oregon also has its own EV rebate program. We'll walk you through what you qualify for — it can significantly reduce your out-of-pocket cost.",
  },
  {
    category: 'ev-hybrid',
    question: 'Can I charge an EV on the Oregon Coast? Is there enough infrastructure?',
    answer:
      "Charging infrastructure on the Oregon Coast has improved significantly. Astoria, Seaside, Cannon Beach, and Tillamook all have Level 2 and DC fast chargers. Most EV owners charge primarily at home overnight. If you're commuting within the region, range anxiety is rarely an issue with modern EVs. We can walk you through charging options for your specific situation.",
  },
  {
    category: 'ev-hybrid',
    question: 'Do you offer financing for EVs and hybrids?',
    answer:
      "Yes — same financing options as any other vehicle. Some lenders offer slightly better rates for EVs due to lower operating costs. We'll shop lenders specifically for your EV purchase and find the best available rate. Federal tax credits can also be applied as a down payment in some cases.",
  },

  // ── Local Services ────────────────────────────────────────────────────────────
  {
    category: 'local-services',
    question: 'Do you serve customers in Astoria, Seaside, and Tillamook, Oregon?',
    answer:
      "Yes — Astoria is 5 miles away, Seaside is 15, Tillamook is 65. We're the go-to alternative for buyers who want access to all makes and models without the single-brand limitations of local dealerships. A lot of Astoria and Seaside customers drive right past the local lots to come see us.",
  },
  {
    category: 'local-services',
    question: 'Can customers from Longview, Kelso, and Long Beach, Washington buy from you?',
    answer:
      "Absolutely. Longview is 55 miles, Kelso is 60, Long Beach is 30. We handle all cross-state paperwork and Washington registration requirements. We've got plenty of Washington customers who'd agree the drive is worth it.",
  },
  {
    category: 'local-services',
    question: 'Do you serve Forest Grove and Hillsboro, Oregon?',
    answer:
      "Yes. Forest Grove is 75 miles, Hillsboro is 80. Portland metro customers make the trip regularly — the drive is scenic and the savings are real. We also offer delivery to Forest Grove and Hillsboro if you'd rather skip the road trip entirely.",
  },
  {
    category: 'local-services',
    question: 'Why should I choose Rockhound Auto over local dealerships?',
    answer:
      "Because we're not limited to one brand, one lot, or one region. We offer every make, model, year, and price point. Our auto broker model means lower overhead, no pressure tactics, transparent pricing, and average savings of $3,000–$8,000. Better trade-in values. More financing options. And a team that actually answers the phone.",
  },

  // ── Vehicle Quality ───────────────────────────────────────────────────────────
  {
    category: 'vehicle-quality',
    question: 'Are your used vehicles inspected before sale?',
    answer:
      "Every vehicle goes through a thorough safety inspection — mechanical systems, electrical components, safety features, cosmetic condition. We don't rush cars to the lot. If something's wrong, we fix it or we tell you about it. We'd rather lose a sale than sell you a problem.",
  },
  {
    category: 'vehicle-quality',
    question: 'Do you offer warranties on used vehicles?',
    answer:
      "Yes. Warranty options vary by vehicle age, mileage, and condition. We'll walk you through what's available and what actually makes sense for the specific car you're buying — not just upsell you on the most expensive package. Call (855) 468-6348 or visit our Warrenton showroom for the honest breakdown.",
  },
  {
    category: 'vehicle-quality',
    question: 'Can I see a vehicle history report before purchasing?',
    answer:
      "Every vehicle comes with a free Carfax or AutoCheck report — accident history, service records, ownership history, title status. We provide it upfront, not after you've already fallen in love with the car. If there's something in the report worth discussing, we'll bring it up first.",
  },
  {
    category: 'vehicle-quality',
    question: 'What types of vehicles do you typically have in stock in Warrenton?',
    answer:
      "Sedans, SUVs, trucks, crossovers, and specialty vehicles from all major manufacturers. Popular Pacific Northwest picks like Toyota Tacoma, Subaru Outback, Honda CR-V, Ford F-150, and Jeep Wrangler show up regularly. We also source luxury vehicles, EVs, and hard-to-find builds through our broker network.",
  },
  {
    category: 'vehicle-quality',
    question: 'Do you sell salvage title or rebuilt title vehicles?',
    answer:
      "No. We don't sell salvage or rebuilt title vehicles. Every vehicle we sell has a clean title. We disclose any prior accidents shown in the vehicle history report and explain what repairs were made. Clean title, clean history, or we don't sell it.",
  },

  // ── First-Time Buyers ────────────────────────────────────────────────────────
  {
    category: 'first-time-buyer',
    question: 'I\'ve never financed a car before — where do I even start?',
    answer:
      'Start with your budget, not the car. Figure out what monthly payment you\'re comfortable with, then work backward to a total price. A good rule of thumb: your total car payment (including insurance) shouldn\'t exceed 15–20% of your take-home pay. Once you have a number, get pre-approved so you know exactly what you can spend before you fall in love with something. Then come talk to us — we\'ll walk you through every step.',
  },
  {
    category: 'first-time-buyer',
    question: 'Do I need a credit history to finance a car for the first time?',
    answer:
      'Not necessarily. Some lenders specialize in "thin file" borrowers — people with little or no credit history. You may need a larger down payment (10–20%) or a co-signer to qualify for better rates. If you have a steady income and can show bank statements, we can usually find a lender willing to work with you. Building credit through an auto loan is actually one of the most common ways first-time buyers establish their credit profile.',
  },
  {
    category: 'first-time-buyer',
    question: 'What credit score do I need as a first-time car buyer?',
    answer:
      'There\'s no hard cutoff. Scores above 650 typically qualify for standard rates. Scores between 580–649 may qualify with a higher rate or larger down payment. Below 580, you\'ll likely need a co-signer or a buy-here-pay-here arrangement — which we\'ll be honest about if that\'s your situation. If you don\'t know your score, check it free at annualcreditreport.com before applying. Knowledge is leverage.',
  },
  {
    category: 'first-time-buyer',
    question: 'Should I get a co-signer for my first auto loan?',
    answer:
      'A co-signer with strong credit can unlock significantly better interest rates and higher loan amounts. It\'s a real option if your own credit is thin or your income is on the lower end. Just make sure your co-signer understands what they\'re agreeing to — if you miss payments, it affects their credit too. We\'ll always show you both scenarios (with and without a co-signer) so you can make an informed decision.',
  },
  {
    category: 'first-time-buyer',
    question: 'How much should I put down on my first car?',
    answer:
      '10–20% is the standard recommendation. On a $15,000 car, that\'s $1,500–$3,000. A larger down payment lowers your monthly payment, reduces total interest paid, and helps you avoid being "upside down" (owing more than the car is worth). If you can\'t hit 10%, don\'t panic — we have lenders who work with lower down payments. But if you can save a bit more before buying, it\'s worth it.',
  },
  {
    category: 'first-time-buyer',
    question: 'What\'s the difference between a loan term of 36, 48, 60, and 72 months?',
    answer:
      'Shorter terms = higher monthly payments, less total interest. Longer terms = lower monthly payments, more total interest. A 36-month loan on $15,000 at 8% APR costs about $470/month and ~$1,900 in interest. The same loan at 72 months costs about $263/month but ~$3,900 in interest — more than double. We\'ll show you a side-by-side breakdown so you can see exactly what each term costs you over the life of the loan.',
  },
  {
    category: 'first-time-buyer',
    question: 'What is APR and why does it matter for my car loan?',
    answer:
      'APR (Annual Percentage Rate) is the true cost of borrowing — it includes the interest rate plus any lender fees, expressed as a yearly percentage. A lower APR means you pay less over the life of the loan. Even a 2% difference on a $15,000 loan over 60 months adds up to $800–$1,000. Always compare APR, not just monthly payment. A dealer who quotes a low payment on a long term at a high APR is not doing you any favors.',
  },
  {
    category: 'first-time-buyer',
    question: 'What documents do I need to apply for my first auto loan?',
    answer:
      'You\'ll typically need: a valid driver\'s license, proof of income (recent pay stubs or bank statements), proof of residence (utility bill or lease agreement), and your Social Security number for the credit check. If you\'re using a co-signer, they\'ll need the same. Having these ready speeds up the process significantly — most approvals come back within a few hours once we have everything.',
  },
  {
    category: 'first-time-buyer',
    question: 'Is it better to finance through a dealer or my own bank as a first-time buyer?',
    answer:
      'Both have merit. Your bank or credit union may offer a loyalty rate if you have an existing account. Dealer financing lets us shop multiple lenders simultaneously, which is especially useful if your credit profile is thin — some lenders specialize in first-time buyers and offer programs your bank won\'t have. Best strategy: get pre-approved by your bank first, then let us try to beat it. You\'re never obligated to use our financing.',
  },
  {
    category: 'first-time-buyer',
    question: 'What is "being upside down" on a car loan and how do I avoid it?',
    answer:
      'Being upside down means you owe more on the loan than the car is currently worth. It happens when you finance 100% of the purchase price, choose a very long loan term, or buy a vehicle that depreciates quickly. To avoid it: put at least 10% down, choose a loan term of 60 months or less, and buy a vehicle with a strong resale value (Toyota, Honda, and Subaru hold value well). We\'ll flag any deal where we think you\'re at risk of going upside down.',
  },
  {
    category: 'first-time-buyer',
    question: 'What is GAP insurance and do I need it as a first-time buyer?',
    answer:
      'GAP (Guaranteed Asset Protection) insurance covers the difference between what you owe on your loan and what your car is worth if it\'s totaled or stolen. It\'s most useful when you finance a high percentage of the vehicle\'s value or choose a long loan term. For first-time buyers putting less than 20% down, GAP is often worth the cost — typically $200–$400 for the life of the loan. We\'ll explain whether it makes sense for your specific deal.',
  },
  {
    category: 'first-time-buyer',
    question: 'What\'s a realistic total monthly cost of owning a car for the first time?',
    answer:
      'Beyond the loan payment, budget for: insurance ($100–$200/month for most first-time buyers), fuel ($80–$150/month depending on commute), routine maintenance ($50–$100/month averaged out), and registration renewal (~$100–$200/year in Oregon). A $250/month loan payment can easily become $500–$600/month all-in. We always encourage buyers to run the full number before committing — not just the sticker price.',
  },
  {
    category: 'first-time-buyer',
    question: 'Should I buy new or used as a first-time buyer?',
    answer:
      'Used is almost always the smarter financial move for first-time buyers. New cars lose 15–25% of their value in the first year. A 2–3 year old vehicle with low miles gives you most of the reliability of new at a fraction of the depreciation hit. You also pay less in insurance and registration fees. We specialize in quality used vehicles — and we\'ll be honest if a specific used car isn\'t worth the savings over new.',
  },
  {
    category: 'first-time-buyer',
    question: 'What are the best used cars for first-time buyers on a budget?',
    answer:
      'Reliability and low ownership cost matter most. Top picks in the $10,000–$18,000 range: Toyota Corolla, Honda Civic, Honda Fit, Mazda3, Subaru Impreza, and Toyota Camry. For SUVs: Honda CR-V, Toyota RAV4, and Subaru Forester. These hold value, have low repair costs, and are easy to insure. Tell us your budget and lifestyle and we\'ll match you with the right vehicle — not just whatever we have on the lot.',
  },
  {
    category: 'first-time-buyer',
    question: 'How do I know if I\'m getting a fair price as a first-time buyer?',
    answer:
      'Research before you shop. Check the vehicle\'s value on KBB (Kelley Blue Book) and Edmunds using the actual year, mileage, and condition. Compare similar listings on CarGurus and AutoTrader in your region. At Rockhound Auto, we price vehicles based on real market data and show you the comparable sales we used. If you think our price is off, bring the data — we\'ll have an honest conversation about it.',
  },
  {
    category: 'first-time-buyer',
    question: 'What questions should I ask before signing my first car loan?',
    answer:
      'Ask these before you sign anything: What is the exact APR? Is there a prepayment penalty? What is the total amount I\'ll pay over the life of the loan (not just monthly)? Is GAP insurance included or optional? What warranties are included vs. add-ons? Are there any fees not shown in the purchase price? We\'ll answer every one of these upfront — and if any dealer won\'t, that\'s your signal to walk.',
  },
];
